import(/* webpackMode: "eager", webpackExports: ["default"] */ "/usr/src/app/libs/shared/pages/docs/components/RightSide/DocContent.jsx");
;
import(/* webpackMode: "eager" */ "/usr/src/app/node_modules/next/dist/client/link.js");
